<mat-checkbox
  [ngModel]="roomExaminationService.getRoomIsClosed()"
  (ngModelChange)="setRoomIsClosed(roomIsClosedCheckbox.checked)"
  #roomIsClosedCheckbox
  >{{ "components.room-not-visited.check-box-label" | translate }}</mat-checkbox
>
@if (roomIsClosedCheckbox.checked) {
  <mat-form-field>
    <mat-label>
      <span class="inline-label">{{
        "components.room-not-visited.mat-select-label" | translate
      }}</span>
    </mat-label>
    <mat-select
      [(ngModel)]="abortionReason"
      (selectionChange)="setAbortionReason($event.value)"
    >
      @for (reason of abortionReasons; track reason) {
        <mat-option [value]="reason">{{
          "enums.roomClosedReason." + reason | translate
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
